<template>
    <div class="d-flex align-items-center justify-content-between border-bottom font-weight-bold">
        <div class="w-50 d-flex align-items-center p-3">
            <div class="w-50">{{stringLimit(deviceObject.getName(), 17)}}</div>
            <div class="w-50 d-flex justify-content-end align-items-center">
                <div class="mr-3">
                    <Icon icon-name="clock"
                          data-toggle="tooltip"
                          data-placement="top"
                          :title="lastUpstreamDateAgo"
                          :fill="iconColor"
                          width="24"
                          height="24"/>
                </div>
                <div class="cursor-pointer mr-3" @click="$router.push({name: 'Device', params: { id: deviceObject.getId() }})">
                    <Icon data-toggle="tooltip"
                          data-placement="top"
                          :data-original-title="$t('Статистика')"
                          icon-name="statistic"
                          width="24"
                          height="24"
                          :fill="iconColor"

                    />
                </div>
                <DeviceCardAccidentsIndicator
                    class="mr-3"
                    :deviceObject="deviceObject"
                    :timeseries="timeseries"
                    :accidents="accidents"
                    @onHasAccidents="val => this.hasAccidents = val"/>
                <DeviceCardHeaderBattery v-if="deviceBatVolt"
                                         class="mr-3"
                                         :deviceObject="deviceObject"
                                         :timeseries="timeseries"/>
                <div class="p-0 m-0 cursor-pointer"
                     data-toggle="tooltip"
                     data-placement="top"
                     :title="$t('Настройки')">
                    <Icon icon-name="setting"
                          data-toggle="dropdown"
                          :fill="iconColor"
                          width="24"
                          height="24"/>
                    <div class="dropdown-menu app-dropdown font-weight-500">
                        <a v-if="isCurrentUserDevice" class="dropdown-item d-flex align-items-center" href="#" @click.prevent="$emit('deviceDoUpdate', deviceObject)">
                            <Icon icon-name="edit"
                                  fill="#390E4E"
                                  width="20"
                                  height="20"/>
                            <span class="pl-2">{{ $t('Редактировать') }}</span>
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="$emit('deviceDoShowGeoPosition', deviceObject)">
                            <Icon icon-name="location"
                                  width="20"
                                  fill="#00800D"
                                  height="20"/>
                            <span class="pl-2">{{ $t('Местоположение') }}</span>
                        </a>
                        <a v-if="isCurrentUserDevice" class="dropdown-item d-flex align-items-center" href="#"
                           @click.prevent="$router.push({name: 'DeviceAlarm', params: { id: deviceObject.getId() }})">
                            <Icon icon-name="info-circle"
                                  width="20"
                                  fill="#FF7B01"
                                  height="20"/>
                            <span class="pl-2">{{ $t('Настройка аварий') }}</span>
                        </a>
                        <a v-if="isCurrentUserDevice" class="dropdown-item d-flex align-items-center" href="#"
                           @click.prevent="$router.push({name: 'Accidents', params: {deviceId: deviceObject.getId() }})">
                            <Icon icon-name="danger"
                                  width="20"
                                  fill="#FF2F2F"
                                  height="20"/>
                            <span class="pl-2">{{ $t('Обзор инцидентов') }}</span>
                        </a>
                        <a v-if="isCurrentUserDevice" class="dropdown-item d-flex align-items-center" href="#"
                           @click.prevent="$router.push({name: 'DeviceAccess', params: { deviceId: deviceObject.getId() }})">
                            <Icon icon-name="shield"
                                  width="20"
                                  fill="#00409F"
                                  height="20"/>
                            <span class="pl-2">{{ $t('Управление доступом') }}</span>
                        </a>
                        <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="switchAutoUpdate">
                            <Icon icon-name="refresh"
                                  width="20"
                                  :fill="isEnabledAutoUpdate ? '#000000' : '#00800D'"
                                  height="20"/>
                            <span class="pl-2">{{ isEnabledAutoUpdate ? $t('Отключить авто-обновление') : $t('Включить авто-обновление') }}</span>
                        </a>
                        <div v-if="isCurrentUserDevice" class="dropdown-divider"></div>
                        <a v-if="isCurrentUserDevice" class="dropdown-item d-flex align-items-center" href="#"
                           @click.prevent="$emit('deviceDoRemove', deviceObject)">
                            <Icon icon-name="delete"
                                  width="20"
                                  fill="#FF0000"
                                  height="20"/>
                            <span class="pl-2">{{ $t('Удалить устройство') }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center w-17 border-left py-3">{{ $t('Показатели') }}</div>
        <div class="text-center w-33 border-left py-3">{{ $t('Статистика') }}</div>
    </div>
</template>

<script>

import _ from "underscore";
import TimeAgo from 'javascript-time-ago';
import ru from 'javascript-time-ago/locale/ru.json';
import uk from 'javascript-time-ago/locale/uk.json';
import {mapState} from "vuex";
import DeviceObject from "../../../objects/DeviceObject";
import types from "../../../store/types";
import Icon from "../../Icon";
import DeviceCardHeaderBattery from "./DeviceCardHeaderBattery";
import DeviceCardAccidentsIndicator from "./DefaultCardAccidentsIndicator";
import Helper from "../../../classess/Helper";
import AccidentsInfo from "./AccidentsInfo";

export default {
    name: "DefaultCardHeader",
    components: {
        AccidentsInfo,
        DeviceCardAccidentsIndicator,
        DeviceCardHeaderBattery,
        Icon
    },
    data: () => ({
        hasAccidents: false,
    }),
    props: {
        deviceObject: {
            type: DeviceObject,
            required: true
        },
        timeseries: {
            type: Array,
            required: false
        },
        accidents: {
            type: Array,
            required: false
        },
    },
    methods: {
        stringLimit: Helper.stringLimit,
        ago(date) {
            if (!date) return this.$t('Нет данных');
            const timeAgo = new TimeAgo(this.$i18n.locale);
            return this.$t("Обновлено") + " " + timeAgo.format(new Date(date));
        },
        isCurrentUserDevice() {
            return this.deviceObject.getAccountId() === this.currentObject?.account_id;
        },
        switchAutoUpdate() {
            let devices = [...this.autoUpdateDevices];

            if (this.isEnabledAutoUpdate) {
                devices = _.without(devices, this.deviceObject.getId());
            } else {
                devices.push(this.deviceObject.getId());
            }

            this.$store.commit(types.SET_AUTO_UPDATE_DEVICES, devices);
        }
    },
    computed: {
        ...mapState({
            currentObject: state => state.currentObject,
            lastUpstreamDateAgo() {
                return this.ago(this.deviceObject.getLastUpstreamDate())
            },
            autoUpdateDevices: state => state.autoUpdateDevices
        }),
        isEnabledAutoUpdate() {
            return this.autoUpdateDevices.indexOf(this.deviceObject.getId()) !== -1;
        },
        deviceBatVolt() {
            return this.deviceObject?.getType()?.getMetrics()?.map(item => item.getSlug()).includes('bat_volt')
        },
        iconColor() {
            return '#858585';
        }
    },
    created() {
        TimeAgo.addLocale(ru);
        TimeAgo.addLocale(uk);
    },
}
</script>

<style lang="less">

.tooltip {
    font-family: Montserrat, sans-serif;
    font-size: .8rem;

    &-inner {
        border-radius: .6rem;
        padding: .5rem 1rem;
    }
}
</style>
